import { useCacheStore } from '@/stores/cache-store'
import { keyBuilderService } from '../../services/key-builder'

/**
 * Verinin cache'de olup olmadığını kontrol eder
 * @param {string} prefix - Cache anahtarı için önek
 * @param {Object} params - Cache anahtarının parametreleri
 * @returns {boolean} Cache'de varsa true
 */
export const has = (prefix, params) => {
  const cacheStore = useCacheStore()
  const key = keyBuilderService.build(prefix, params)
  return cacheStore.get(key) !== null
}